import { Box } from "@mui/material";
import { styled } from "styled-components";

export const ContentList = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const AccordionContent = styled(Box)`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;
